<template>
  <div id="emulation">
    <my-header activeIndex="仿真平台" />
    <div class="banner"></div>
    <div class="wrapper">
      <div class="software">
        <div class="title">Noosphere仿真软件</div>
        <ul class="content clearfix">
          <li v-for="(item, index) in list" :key="index">
            <div class="scale-image">
              <img
                :src="require(`../../assets/images/emulation${index + 1}.jpg`)"
              />
            </div>
            <div>
              <h1>
                <span>{{ item.name }}</span>
              </h1>
              <p>
                {{ item.des }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="feature">
        <div class="title">开放功能</div>
        <div class="content clearfix">
          <div class="left">
            <ul>
              <li>核心功能</li>
            </ul>
          </div>
          <div class="center">
            <ul>
              <li>车道识别</li>
              <li>自动泊车</li>
              <li>碰撞检测</li>
            </ul>
          </div>
          <div class="right">
            <ul>
              <li>
                <div>
                  基于实验 <br />
                  的教学研发迭代仿真
                </div>
              </li>
              <li>
                <div>高精地图仿真场景</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <my-footer />
  </div>
</template>
<script>
import MyHeader from "@/components/header";
import MyFooter from "@/components/footer";
export default {
  name: "emulation",
  data() {
    return {
      list: [
        {
          name: "Dreamview",
          des:
            "Dreamview可以在浏览器中模拟展示真车在实际场景中的运动环境和运行状态。"
        },
        {
          name: "Panosim",
          des:
            "PanoSim是新一代智能汽车仿真软件，具有多种仿真模型，可方便地进行场景构建和算法MDL搭建，可用于智能驾驶算法的快速开发和验证。"
        },
        {
          name: "LGSVL",
          des:
            "LGSVL是一种真实场景模拟器，可促进自动驾驶软件系统的测试和开发。它使开发人员能够模拟数十亿英里和任意边缘情况，以加快算法开发和系统集成的速度。 "
        }
      ]
    };
  },
  components: { MyHeader, MyFooter }
};
</script>
<style lang="less">
#emulation {
  color: #333333;
  background: #f8fbff;
  .banner {
    width: 100%;
    padding-top: 24%;
    background: url("../../assets/images/emulationbanner.jpg");
    background-size: 100% 100%;
  }
  .title {
    line-height: 100px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
  }
  .software {
    .title {
      padding: 25px 0 45px;
    }
    .content {
      li {
        float: left;
        width: 378px;
        margin-right: 33px;
        background: #ffffff;
        &:last-child {
          margin-right: 0;
        }
        > div {
          height: 268px;
          &:last-child {
            height: 212px;
            box-shadow: 0 0 9px rgba(0, 0, 0, 0.15);
          }
        }
        h1 {
          padding-top: 12px;
          font-size: 24px;
          line-height: 64px;
          text-align: center;
        }
        p {
          padding: 0 35px;
          font-size: 16px;
          line-height: 28px;
          text-align: justify;
        }
      }
    }
  }

  .feature {
    .title {
      padding-top: 65px;
    }
    .content {
      padding: 0 125px 60px;
      > div {
        float: left;
        li {
          text-align: center;
          font-size: 18px;
          letter-spacing: 5px;
          background: #e2e9f3;
        }
      }
      .left {
        width: 150px;
        padding-right: 30px;
        li {
          height: 265px;
          line-height: 265px;
        }
      }
      .center {
        width: 450px;
        padding-right: 30px;
        li {
          height: 75px;
          line-height: 75px;
          margin-bottom: 20px;
        }
      }
      .right {
        width: 290px;
        li {
          margin-bottom: 35px;
          div {
            display: table-cell;
            vertical-align: middle;
            width: 290px;
            height: 115px;
          }
        }
      }
    }
  }
}
</style>
